import { TranslatableName } from '@interfaces/dws/translatable-name';

export type ProductType = TranslatableName;

export const orderedProductTypes = [
    'wine',
    'food',
    'beer',
    'oil',
    'bitters_spirits',
    'services',
    'other',
];

export function orderProductTypes(productTypes: ProductType[]): ProductType[] {
    return productTypes.sort((a, b) => {
        const indexA = orderedProductTypes.indexOf(a.id);
        const indexB = orderedProductTypes.indexOf(b.id);

        const safeIndexA = indexA === -1 ? Number.MAX_SAFE_INTEGER : indexA;
        const safeIndexB = indexB === -1 ? Number.MAX_SAFE_INTEGER : indexB;

        return safeIndexA - safeIndexB;
    });
}